import React from "react";
import { useNavigate } from "react-router-dom";
import { IconProps, Modal, ModalBody } from "@velaro/velaro-component-lib";

interface NetSuiteConfig {
  id: number;
  displayName: string;
  company: string;
  teamId: number;
  createdAt: string;
}

interface IntegrationsModalProps {
  show: boolean;
  onClose: () => void;
  appId: string;
  appName: string;
  icon?: string | ((props: IconProps) => JSX.Element);
  teamId: number;
  appStatus?: string;
  configId: string;
}

const IntegrationsModal: React.FC<IntegrationsModalProps> = ({
  show,
  onClose,
  appId,
  appName,
  icon,
  teamId,
  appStatus,
  configId
}) => {
  const history = useNavigate();

  const handleConnect = () => {
    history(`/integrations/${appId}/netsuitecreate`, {
      state: { teamId, appStatus, configId }
    });
    onClose();
  };

  return (
    <Modal show={show}>
      <ModalBody>
        <div className="flex items-center mb-6">
          {icon && (
            <div className="w-14 h-14 border-slate-300 relative mr-4 rounded border p-1 content-center">
              {typeof icon === "string" ? (
                <img src={icon} alt={appName} />
              ) : icon ? (
                React.createElement(icon)
              ) : null}
            </div>
          )}
          <div className="flex flex-col">
            <span className="text-slate-800 text-base font-medium">
              {appName}
            </span>
            {appStatus !== "" && (
              <span
                className={`rounded border justify-center items-center w-fit px-1 ${
                  appStatus !== "Connected"
                    ? "bg-[#c8f2db] border-[#c8f2db]"
                    : "bg-slate-300 border-slate-300"
                }`}
              >
                {appStatus}
              </span>
            )}
          </div>
        </div>

        <div className="pt-6">
          <span className="text-slate-800 text-sm font-medium">
            Key Features
          </span>
          <ul className="list-disc pl-4">
            <li className="text-slate-800 text-sm font-normal mt-2">
              Access NetSuite customer records directly within the chat window
              for real-time insights.
            </li>
            <li className="text-slate-800 text-sm font-normal mt-2">
              Automatically sync data, including conversations, surveys, and
              chatbot interactions, to NetSuite.
            </li>
            <li className="text-slate-800 text-sm font-normal mt-2">
              Map Velaro interactions to NetSuite records such as Customers,
              Contacts, and Support Cases.
            </li>
            <li className="text-slate-800 text-sm font-normal mt-2">
              Enable automated workflows to update NetSuite data based on chat
              engagements.
            </li>
          </ul>

          <div className="justify-center items-center gap-4 inline-flex mt-10 w-full">
            <button
              onClick={onClose}
              className="rounded-lg justify-start items-center flex px-6 py-2 bg-white rounded-lg border border-primary hover:border-primary-hover text-center text-[#1670e7] text-sm font-medium"
            >
              Cancel{" "}
            </button>
            <button
              onClick={handleConnect}
              className="rounded-lg justify-start items-center flex px-6 py-2 rounded-lg border border-primary bg-primary border-primary hover:bg-primary-hover hover:border-primary-hover text-center text-white text-sm font-medium"
            >
              Connect{" "}
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default IntegrationsModal;
